import Storage from '@/utils/storage'

const VALIDATION_DEFAULT_STATE = { hasError: false }

const state = {
  id: Storage.getIdNumber() || '',
  dob: '',
  errorCode: '',
  errorTitle: '',
  errorMessage: '',
  errorScreenType: '',
  input: {
    id: '',
    dob: { day: '', month: '', year: '' },
  },
  validation: {
    id: VALIDATION_DEFAULT_STATE,
    dob: {
      day: VALIDATION_DEFAULT_STATE,
      month: VALIDATION_DEFAULT_STATE,
      year: VALIDATION_DEFAULT_STATE,
    },
  },
}

const getters = {
  dobValidation(state) {
    return state.validation?.dob || {}
  },
  idHasError(state) {
    return Boolean(state.validation?.id?.hasError)
  },
}

const mutations = {
  SET_ID: (state, newId) => {
    state.id = newId || ''
  },
  SET_DOB: (state, newDob) => {
    state.dob = newDob || ''
  },
  SET_ERROR_CODE: (state, code) => {
    state.errorCode = code
  },
  SET_ERROR_RESULT: (state, errorData = {}) => {
    state.errorCode = errorData?.errorCode || ''
    state.errorTitle = errorData?.errorTitle || ''
    state.errorMessage = errorData?.errorMessage || ''
    state.errorScreenType = errorData?.errorScreenType || ''
  },
  SET_ID_INPUT: (state, id) => {
    state.input.id = id
  },
  SET_DOB_INPUT: (state, dob = {}) => {
    state.input.dob = { ...dob }
  },
  SET_ID_VALIDATION: (state, hasError) => {
    state.validation.id = { hasError }
  },
  SET_DOB_DAY_VALIDATION: (state, hasError) => {
    state.validation.dob.day = { hasError }
  },
  SET_DOB_MONTH_VALIDATION: (state, hasError) => {
    state.validation.dob.month = { hasError }
  },
  SET_DOB_YEAR_VALIDATION: (state, hasError) => {
    state.validation.dob.year = { hasError }
  },
}

const actions = {
  cachePersonalInformation({ commit }, info) {
    commit('SET_ID', info.id)
    commit('SET_DOB', info.dob)

    Storage.setIdNumber(info.id || '')
  },
  setErrorCode({ commit }, errorCode) {
    commit('SET_ERROR_CODE', errorCode)
  },
  setErrorResult({ commit }, error) {
    commit('SET_ERROR_RESULT', error)
  },
  setUserIdInput({ commit }, id) {
    commit('SET_ID_INPUT', id)
  },
  setUserDobInput({ commit }, dob) {
    commit('SET_DOB_INPUT', dob)
  },
  setIdValidation({ commit }, hasError) {
    commit('SET_ID_VALIDATION', hasError)
  },
  setDobDayValidation({ commit }, hasError) {
    commit('SET_DOB_DAY_VALIDATION', hasError)
  },
  setDobMonthValidation({ commit }, hasError) {
    commit('SET_DOB_MONTH_VALIDATION', hasError)
  },
  setDobYearValidation({ commit }, hasError) {
    commit('SET_DOB_YEAR_VALIDATION', hasError)
  },
}

export default { namespaced: true, state, getters, mutations, actions }
